<template>
	<div>
		<el-row :gutter="10">
			<!-- 左边 -->
			<el-col :xs="0" :sm="14" :md="14" :lg="14" :xl="14" :offset="2">
			  <div class="grid-content left">
				  <div class="position">
					<el-breadcrumb separator-class="el-icon-d-arrow-right">
					  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  <el-breadcrumb-item>{{breadcrumb(id)}}</el-breadcrumb-item>
					</el-breadcrumb>  
				  </div>
				  <div class="search">
					<el-row :gutter="60">
<!-- 						<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
							<el-select v-model="value" filterable clearable  placeholder="请选择类型">
								<el-option
								  v-for="item in types"
								  :key="item.value"
								  :label="item.label"
								  :value="item.value">
								</el-option>
							</el-select>
						</el-col> -->
						<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
						<el-select v-model="hangyeId" filterable clearable placeholder="请选择行业" @change="onHangYeChange" @clear="onClear">
							<el-option
							  v-for="item in hangyes"
							  :key="item.Id"
							  :label="item.name"
							  :value="item.Id">
							</el-option>
						</el-select>
						</el-col>
						<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
						<el-select v-model="provinceId" filterable clearable placeholder="请选择省份" @change="onProvinceChange" @clear="onClear">
							<el-option
							  v-for="item in provinces"
							  :key="item.Id"
							  :label="item.name"
							  :value="item.Id">
							</el-option>
						</el-select>
						</el-col>
						<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
						<el-select v-model="statussId" filterable clearable placeholder="请选择状态" @change="onStatusChange" @clear="onClear">
							<el-option
							  v-for="item in statuss"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select>
						</el-col>
					</el-row>
					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<div class="searchInput" style="width:100%">
							<el-input placeholder="请输入关键词" v-model="keywords" class="input-with-select" style="border-radius: 5px;width:100%;margin-top:10px;">
								<el-button type="primary" slot="append" icon="el-icon-search" style="background-color: #409EFF;color: #fff;height: 40px;width:100px;margin-right:-21px;" class="searchBtn" @click="search(keywords)">搜索</el-button>
							</el-input>
						</div>
				    </el-col>
				  </div>
				  <div class="contentList">
					  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						    <el-table
						      :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
						      border
						      style="width: 100%">
						      <el-table-column
								header-align="center"
						        prop="title"
						        label="标题">
								<template slot-scope="props">
									<el-link type="primary" @click="handle(props.row.Id)" v-if="props.row.hangye_id" :underline="false">{{props.row.title.slice(0,36)}}</el-link>
									<el-link type="primary" @click="$router.push('/newsdetails/id/'+ props.row.Id)" v-else :underline="false">{{props.row.title.slice(0,36)}}</el-link>
								</template>
						      </el-table-column>
							  <el-table-column
								align="center"
							    prop="endtime"
							    label="创建时间"
							    width="110">
								<template slot-scope="props">
									{{$utils.timestampToTimes(props.row.createtime*1000)}}
								</template>
							  </el-table-column>
						    </el-table>
							<div class="pagination">
								<el-pagination
								  :background="true"
								  :pager-count="pagerCount"
								  :page-size = "pageSize"
								  :page-sizes="[5,10,20]"
								  :current-page = "currentPage"
								  @current-change="currentChange"
								  @size-change="handleSizeChange"
								  prev-text ="上一页"
								  next-text = "下一页"
								  layout="prev, pager, next"
								  :total="total">
								</el-pagination>
							</div>
					</el-col>
				  </div>
			  </div>
			</el-col>
			<!-- 右边 -->
			<el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6">
				<div class="grid-content first">
					<el-carousel :interval="6000" arrow="never">
						<el-carousel-item v-for="item in bannerTop" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content second">
					<div class="listHeader">
						采购中心
					</div>
					<el-card class="box-card">
					  <div v-for="o in caigoulist.slice(0,4)" :key="o.Id" class="text item" @click="handle(o.Id)">
						{{o.title.substring(0,22)}}
					  </div>
					</el-card>  
				</div>
				<div class="grid-content third">
					<el-carousel :interval="5000" arrow="never">
						<el-carousel-item v-for="item in bannerMiddle" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content four">
					<div class="listHeader">
						散单需求
					</div>
					<el-card class="box-card">
					  <div v-for="o in sandanlist.slice(0,4)" :key="o.Id" class="text item" @click="handle(o.Id)">
						{{o.title.substring(0,22)}}
					  </div>
					</el-card>    
				</div>
			</el-col>
		</el-row>
		<!-- 手机端 -->
		<el-row>
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
				<div class="search">
					<el-row :gutter="10">
						<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
						<el-select v-model="hangyeId" filterable clearable placeholder="行业" @change="onHangYeChange" @clear="onClear">
							<el-option
							  v-for="item in hangyes"
							  :key="item.Id"
							  :label="item.name"
							  :value="item.Id">
							</el-option>
						</el-select>
						</el-col>
						<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
						<el-select v-model="provinceId" filterable clearable placeholder="省份" @change="onProvinceChange" @clear="onClear">
							<el-option
							  v-for="item in provinces"
							  :key="item.Id"
							  :label="item.name"
							  :value="item.Id">
							</el-option>
						</el-select>
						</el-col>
						<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
						<el-select v-model="statussId" filterable clearable placeholder="状态" @change="onStatusChange" @clear="onClear">
							<el-option
							  v-for="item in statuss"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select>
						</el-col>
					</el-row>
					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<div class="searchInput" style="width:100%">
							<el-input placeholder="请输入关键词" v-model="keywords" class="input-with-select" style="border-radius: 5px;width:100%;margin-top:10px;">
								<el-button type="primary" slot="append" icon="el-icon-search" style="background-color: #409EFF;color: #fff;height: 40px;width:100px;margin-right:-21px;" class="searchBtn" @click="search(keywords)" >搜索</el-button>
							</el-input>
						</div>
				  </el-col>
				</div>
			</el-col>
			<div class="contentList">
			  <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0" style="margin-top: 20px;">
					<el-table
					  :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
					  border
					  :show-header="false"
					  style="width: 100%">
					  <el-table-column
						header-align="center"
						prop="title"
						label="标题"
						>
						<template slot-scope="props">
							<el-link type="primary" @click="handle(props.row.Id)" :underline="false">{{props.row.title}}</el-link>
							<div>
								<i class="el-icon-location-outline"></i>{{props.row.province}}
								<i class="el-icon-price-tag" style="padding-left: 5px;"></i>{{props.row.hangye}}
								<i class="el-icon-time" style="padding-left: 5px;"></i>{{$utils.timestampToTimes(props.row.endtime*1000)}}
							</div>
							<div>
								项目状态：<span :class="props.row.status == 4 ? 'red':''">{{status(props.row.status)}}</span>
							</div>
						</template>
					  </el-table-column>
					</el-table>
					<div class="pagination" style="margin-bottom:30px">
						<el-pagination
							:background="true"
						  :pager-count="pagerCount"
						  :page-size = "pageSize"
						  :page-sizes="[5,10,20]"
						  :current-page = "currentPage"
						  @current-change="currentChange"
						  @size-change="handleSizeChange"
						  prev-text ="上一页"
						  next-text = "下一页"
						  layout="prev, pager, next"
						  :total="total">
						</el-pagination>

					</div>
					<!-- 分页器 -->
					
			</el-col>
			</div>
		</el-row>
	</div>
</template>

<script>
export default {
	name:'list',
	metaInfo() {
	  return {
		title: this.metaName,
		meta: [
		  { charset: "utf-8" },
		  { name: "keywords", content: this.metaKeywords },
		  { name: "description", content: this.metaDecs },
		],
	  };
	},
  data() {
    return {
		id:'',
		total:22,
		currentPage:1,
		pageSize:20,
		pagesize:20,
		pagerCount:5,
		// pagercount:3,
		bannerTop:[],
		bannerMiddle:[],
		domain:this.$utils.httpUrl,
		metaName: "",
		title:"",
		metaKeywords: "",
		metaDecs: "",
		loading: false,
		post: null,
		error: null,
		keywords:'',
		hangyes:[],
		provinces:[],
		keywordss:'',
		statuss:[{value:3,label:'进行中'},{value:4,label:'已结束'}],
		hangyeId: '',
		provinceId:'',
		statussId:'',
		zhaobiaolist:[],
		sandanlist:[],
		caigoulist:[],
		tableData: []
    }
  },
  mounted() {
	this.keywordss = this.$route.params.keywords
	this.searchs()
  },
  created() {
	this.getBanners() 
	this.getZhaobiao()
	this.getHangyes()
	this.getProvinces()
	this.getCaigou()
	this.$axios({
		url:this.$utils.httpApi + 'index/webconfig'
	}).then(res=>{
		this.metaName = this.keywords + '搜索结果 - ' + res.data.data.webtitle
		this.metaDecs = res.data.data.webdescription
		this.metaKeywords = res.data.data.webkeywords
	})
  },
  methods: {
	searchs(){
		this.$axios({
			url:this.$utils.httpApi + 'index/search',
			method:'post',
			data:{'keyword':this.keywordss}
		}).then(res=>{
			console.log(res)
			this.tableData = res.data.data
			this.total = this.tableData.length
		})
		
	},
	onHangYeChange(value){
		this.tableData = this.tableData.filter((res)=>{
			return res.hangye_id == value
		})
	},
	onClear(){
		if(this.id == 2){
			this.tableData = this.zhaobiaolist
		}else if(this.id == 4){
			this.tableData = this.sandanlist
		}
	},
	onProvinceChange(value){
		this.tableData = this.tableData.filter((res)=>{
			return res.province_id == value
		})
	},
	onStatusChange(value){
		this.tableData = this.tableData.filter((res)=>{
			return res.status == value
		})
	},
	search(keyword){
		this.tableData = this.tableData.filter((res)=>{
			return res.title.indexOf(keyword) != -1
		})
	},
	breadcrumb(id){
		if(id == 2){
			return '招标公告'
		}else if(id == 4){
			return '散单需求'
		}else{
			return '搜索结果'
		}
	},
	getHangyes(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getHangyes'
		}).then(res=>{
			this.hangyes = res.data.data
		})
	},
	getProvinces(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getProvinces'
		}).then(res=>{
			this.provinces = res.data.data
		})
	},
	getZhaobiao(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getZhaobiao'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.typelist == 0 && resp.status > 2){
					this.zhaobiaolist.push(resp)
					if(this.id == 2){
						this.tableData = this.zhaobiaolist
						this.total = this.tableData.length
					}
				}else if(resp.typelist == 1 && resp.status > 2){
					this.sandanlist.push(resp)
					if(this.id == 4){
						this.tableData = this.sandanlist
						this.total = this.tableData.length	
					}
				}
			})
		})   
	},
	getBanners(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getBanner'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.type == 4){
					this.bannerTop.push(resp)
				}else if(resp.type == 5){
					this.bannerMiddle.push(resp)
				}
			})
		}) 
	},
    // fetchData() {
    //   this.error = this.post = null
    //   this.loading = true
      // replace `getPost` with your data fetching util / API wrapper
      // getPost(this.$route.params.id, (err, post) => {
      //   this.loading = false
      //   if (err) {
      //     this.error = err.toString()
      //   } else {
      //     this.post = post
      //   }
      // })
    //},
	handleSizeChange(pageSize){
		// console.log('handleSizeChange',pageSize)
		 this.pagesize = pageSize
	},
	currentChange(pageNum){
		// console.log('currentChange',pageNum)
		this.currentPage = pageNum; 
	},
	handle(id){
		// console.log(id);
		this.$router.push('/details/id/'+id)
	},
	status(stat){
		if(stat == 2){
			return '未开始'
		}else if(stat == 3){
			return '进行中'
		}else if(stat == 4){
			return '已结束'
		}  
	},
	getCaigou(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getCaigou'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.typelist == 0){
					this.caigoulist.push(resp)
				}
			})
		})   
	},
  },
  watch: {
      $route() {
		if(this.$route.params.keywords != null){
			this.keywordss = this.$route.params.keywords
			this.searchs()
		}
        if (this.$route.params.id != null) {
          this.id = this.$route.params.id
		  if(this.id == 2){
			  this.tableData = this.zhaobiaolist
			  this.metaName = '招标公告 - ' + this.title
		  }else if(this.id == 4){
			  this.tableData = this.sandanlist
			  this.metaName = '散单需求 - ' + this.title
		  }
        }
      },
    },
}
</script>

<style scoped>
	.red{
		color:red
	}
	.text{
		cursor: pointer;
		color:#409EFF;
	}
	.el-col {
		border-radius: 4px;
	}
	.bg-purple-dark {
		background: #99a9bf;
	}
	.bg-purple {
		background: #d3dce6;
	}
	.bg-purple-light {
		background: #e5e9f2;
	}
	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}
	.search{
		margin:10px auto;
	}
	.contentList{
		margin-top: 60px;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
	.text {
		font-size: 14px;
	}

	.item {
		padding: 18px 0;
	}

	.box-card {
		/* width: 480px; */
	}	
	.listHeader{
		background-color: #409EFF;
		width:100%;
		height:40px;
		color:#fff;
		line-height: 40px;
		text-align: center;
		font-size: 1.1rem;
		font-weight: 700;
		margin-top: 10px;
	}
	.second{
		margin-bottom: 10px;
	}
</style>